enum WizStepId {
  Style = 'style',
  Finish = 'finish',
  Size = 'size',
  Accessory = 'accessory',
}

export default WizStepId;
